Ext.define('SA.view.plugin.DragReorder', {
    alias: 'plugin.sa-drag-reorder',
    extend: 'Ext.AbstractPlugin',
    pluginId: 'sa-drag-reorder',

    direction: 'vertical',
    dragScrolling: true,
    isDrag: false,
    resetEvent: 'afterlayout',

    horizontal: {
        clientSize: 'clientWidth',
        offsetPosition: 'offsetLeft',
        positionGetter: 'getX',
        scrollSize: 'scrollWidth',
        scrollPosition: 'scrollLeft',
        sizeGetter: 'getWidth',
        translateProperty: 'translateX'
    },

    vertical: {
        clientSize: 'clientHeight',
        offsetPosition: 'offsetTop',
        positionGetter: 'getY',
        scrollSize: 'scrollHeight',
        scrollPosition: 'scrollTop',
        sizeGetter: 'getHeight',
        translateProperty: 'translateY'
    },

    afterDrag: Ext.emptyFn,
    afterMove: Ext.emptyFn,
    beforeDrag: Ext.emptyFn,

    init() {
        Object.assign(this, this[this.direction]);

        this.cmp.on('afterrender', this.afterRender, this, {single: true});
    },

    afterRender() {
        this.cmp.el.on('mousedown', this.onMouseDown, this, {delegate: this.dragHandleSelector || this.itemSelector});
    },

    getParentEl() {
        return this.getScrollEl();
    },

    getScrollEl() {
        return this.cmp.el.dom;
    },

    isDragging() {
        return this.isDrag;
    },

    onMouseDown(ev) {
        ev.preventDefault();

        var me = this,
            scrollPosition = this.scrollPosition,
            positionGetter = this.positionGetter,
            itemEl = ev.getTarget(this.itemSelector),
            cmp = this.cmp,
            initialPointerY = ev[positionGetter](),
            pointerY = initialPointerY,
            doc = Ext.getDoc(),
            scrollEl = this.getScrollEl(),
            parentEl = this.getParentEl(),
            items = Ext.fly(parentEl).query(this.itemSelector),
            itemIndex = items.indexOf(itemEl),
            thresholds = [],
            currentTargetIndex = itemIndex,
            initialScrollTop = scrollEl[scrollPosition],
            scrollHeight = scrollEl[this.scrollSize],
            clientHeight = scrollEl[this.clientSize],
            len, gap, topAdjust, itemTops, adjustedItemTops, adjustedItemHeights, itemHeights, itemTop,
            itemHeight, scrollTask, dragMask;

        this.isDrag = false;

        Ext.Array.removeBy(items, dom => dom.offsetHeight === 0 && dom.offsetWidth === 0);

        len = items.length;

        if (len < 2) {
            return;
        }

        itemTops = items.map(dom => {
            var offset = 0;

            do {
                offset += dom[this.offsetPosition];
                dom = dom.offsetParent;
            } while (dom !== parentEl);

            return offset;
        });

        itemHeights = items.map(dom => Ext.fly(dom)[this.sizeGetter]());

        gap = itemTops[1] - itemTops[0] - itemHeights[0];

        adjustedItemTops = itemTops.slice();
        adjustedItemHeights = itemHeights.slice();
        itemTop = itemTops[itemIndex];
        itemHeight = adjustedItemHeights.splice(itemIndex, 1)[0];

        if (itemIndex !== len - 1) {
            topAdjust = itemTops[itemIndex + 1] - itemTop;

            for (let index = itemIndex ; index < len - 1 ; ++index) {
                adjustedItemTops[index] = adjustedItemTops[index + 1] - topAdjust;
            }

            adjustedItemTops[len - 1] = itemTops[len - 1] + itemHeights[len - 1] - itemHeight;
        }

        for (let index = 0 ; index < len - 1 ; ++index) {
            thresholds.push(adjustedItemTops[index] + (gap + adjustedItemHeights[index]) / 2);
        }

        doc.on('mousemove', mousemove);
        doc.on('mouseup', mouseup);
        doc.on('keydown', keydown);

        function mousemove(ev) {
            pointerY = ev[positionGetter]();

            updatePositions();
        }

        function keydown(ev) {
            if (ev.getKey() !== ev.ESC) {
                return;
            }

            pointerY =  initialPointerY - scrollEl[scrollPosition] + initialScrollTop;

            updatePositions();

            mouseup();
        }

        function updatePositions() {
            var scrollTop = scrollEl[scrollPosition],
                delta = pointerY - initialPointerY + scrollTop - initialScrollTop,
                offset = scrollTop - delta - itemTop,
                sign = -1;

            clearTimeout(scrollTask);

            if (!me.isDrag && Math.abs(delta) > 3) {
                if (me.beforeDrag(itemEl) === false) {
                    mouseup();
                    return;
                }

                me.isDrag = true;

                Ext.fly(itemEl).addCls(me.itemDragCls);

                dragMask = document.createElement('div');
                Ext.fly(dragMask).addCls('sa-drag-mask');
                document.body.appendChild(dragMask);
            }

            if (me.isDrag) {
                if (offset < 0) {
                    offset = itemHeight - clientHeight - offset;
                    sign = 1;
                }

                if (offset > 0) {
                    offset = Math.ceil(offset / 3);

                    if (offset > 20) {
                        offset = 20;
                    }

                    if (me.dragScrolling) {
                        scrollEl[scrollPosition] = Ext.Number.constrain(scrollTop + offset * sign, 0, scrollHeight - clientHeight);
                        scrollTask = setTimeout(updatePositions, 30);
                    }

                    delta += scrollEl[scrollPosition] - scrollTop;
                }

                delta = Ext.Number.constrain(delta, -itemTop, scrollHeight - itemTop - itemHeight);

                me.translateItem(itemEl, delta, null);

                currentTargetIndex = 0;

                thresholds.forEach((val, index) => {
                    if (itemTop + delta > val) {
                        currentTargetIndex = index + 1;
                    }
                });

                items.forEach((item, index) => {
                    if (item === itemEl) {
                        return;
                    }

                    var originallyBefore = index < itemIndex,
                        adjustedIndex = index - (originallyBefore ? 0 : 1),
                        currentlyBefore = adjustedIndex < currentTargetIndex;

                    if (originallyBefore === currentlyBefore) {
                        me.translateItem(item, 0, 100);

                        return;
                    }

                    if (originallyBefore) {
                        me.translateItem(item, itemHeight + gap, 100);
                    }
                    else {
                        me.translateItem(item, -(itemHeight + gap), 100);
                    }
                });
            }
        }

        function mouseup() {
            doc.un('mousemove', mousemove);
            doc.un('mouseup', mouseup);
            doc.un('keydown', keydown);

            clearTimeout(scrollTask);

            if (!me.isDrag) {
                return;
            }

            var targetTop = adjustedItemTops[currentTargetIndex];

            me.translateItem(itemEl, targetTop - itemTop, 100);

            setTimeout(() => {
                Ext.fly(itemEl).removeCls(me.itemDragCls);

                if (dragMask) {
                    dragMask.parentNode.removeChild(dragMask);
                    dragMask = null;
                }

                me.isDrag = false;

                me.afterDrag(itemEl);

                if (currentTargetIndex === itemIndex) {
                    me.resetStyles();
                }
                else {
                    cmp.on(me.resetEvent, me.resetStyles, me, {single: true});

                    me.afterMove(itemIndex, currentTargetIndex);
                }
            }, 120);
        }
    },

    resetStyles() {
        var parentEl = this.getParentEl(),
            items = Ext.fly(parentEl).query(this.itemSelector);

        items.forEach(item => {
            this.translateItem(item, null, null);
        });
    },

    translateItem(item, distance, duration) {
        if (distance != null) {
            distance = this.translateProperty + '(' + distance + 'px)';
        }

        if (duration != null) {
            duration = 'transform ' + duration + 'ms';
        }

        this.translateItemImpl(item, distance, duration);
    },

    translateItemImpl(item, transform, transition) {
        Ext.fly(item).setStyle({transform, transition});
    }
});